export default __webpack_public_path__ + "static/assets/13389f21fb304fc1a91436d68cf579fb.png";